// removed by extract-text-webpack-plugin
module.exports = {"card":"status-details__card___HQmrP globals__card___rNbQM","cardHeader":"status-details__cardHeader___1sL01 globals__cardHeader___39ROk","cardBody":"status-details__cardBody___2cY12 globals__cardBody___43nPd","linkWrapper":"status-details__linkWrapper___mGkGA","icon":"status-details__icon___1Llv8 globals__icon___2kiCi","link":"status-details__link___20F3D globals__link___3RT55","timeslot":"status-details__timeslot___1ZYzt","status":"status-details__status___1yUdW"};


//////////////////
// WEBPACK FOOTER
// ./src/components/status-details/status-details.scss
// module id = 596
// module chunks = 0